module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gal_layer_on-740857025824b7d3540d323e1205462b.png";